import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Toolbar, Typography, createStyles, WithStyles } from '@material-ui/core';
import CalendarIcon from '@material-ui/icons/PermContactCalendar';
import { ISubscription } from '../models/Interfaces';

const styles = createStyles({
  overview: {
    flex: 1,
  },
});

interface IProps extends WithStyles<typeof styles> {
  subscriptions: ISubscription[];
}

function renderSubscription(subscription: ISubscription) {
  const currentPeriodEnd = new Date(subscription.currentPeriodEnd);
  const daysLeft = (currentPeriodEnd.getTime() - new Date().getTime()) / 86400000;

  return (
    <React.Fragment>
      <CalendarIcon color="secondary" />
      <Typography variant="caption" style={daysLeft <= 30 ? { color: 'red' } : undefined}>
        Subscription valid until {currentPeriodEnd.toLocaleDateString()}
      </Typography>
    </React.Fragment>
  );
}

const TransportsToolbar = (props: IProps) => {
  const { subscriptions, classes } = props;

  return (
    <Toolbar>
      <Typography variant="subheading" className={classes.overview}>
        Overview of Invoices
      </Typography>
      {subscriptions.length ? renderSubscription(subscriptions[0]) : null}
    </Toolbar>
  );
};

export default withStyles(styles)(TransportsToolbar);



// WEBPACK FOOTER //
// ./src/modules/billing/pages/SubscriptionToolbar.tsx